import geographyData from '@/assets/geography.json';
import countryData from '@/assets/country.json';
import { ICountry, IGeography } from '@/interfaces/geography';

const geographys: IGeography[] = geographyData;

const searchGeography = (query: string): IGeography[] => {
  return geographys
    .filter(
      geographys =>
        geographys.provinceNameEn.toLowerCase().includes(query.toLowerCase()) ||
        geographys.provinceNameTh.includes(query) ||
        geographys.districtNameEn.toLowerCase().includes(query.toLowerCase()) ||
        geographys.districtNameTh.includes(query) ||
        geographys.subdistrictNameEn
          .toLowerCase()
          .includes(query.toLowerCase()) ||
        geographys.postalCode
          .toString()
          .toLowerCase()
          .includes(query.toLowerCase()) ||
        geographys.subdistrictNameTh.includes(query),
    )
    .slice(0, 20);
};

const getGeography = (postalCode: number): IGeography | undefined => {
  return geographys.find(g => g.postalCode === postalCode);
};

const getGeographyBySubdistrictCode = (
  subdistrictCode: number,
): IGeography | undefined => {
  return geographys.find(g => g.subdistrictCode === subdistrictCode);
};

const getCountry = (): ICountry[] => {
  return countryData;
};

export {
  searchGeography,
  getGeography,
  getGeographyBySubdistrictCode,
  getCountry,
};
